import { Legend_Config, Tooltip_Config, CircleConfig } from '@blade-sxp/portrait-center/utils/common-chart-config';
import { Scale } from '@blade/common/utils/auto-scale';
import { merge } from 'lodash';
import colors from '@/styles/color.scss';
const getDougnutSeries = () => ({
    type: 'pie',
    radius: [23 * Scale, 46 * Scale],
    ...CircleConfig.series,
    avoidLabelOverlap: true,
    label: {
        show: true,
        formatter: `{d}%`,
    },
    labelLine: {
        show: true,
        showAbove: true,
        lineStyle: {
            color: colors.eChartPieLabelLine
        }
    },
    data: [],
});
const getCommonDougnutOption = () => ({
    legend: {
        orient: 'horizontal',
        formatter: ('{name}'),
        ...Legend_Config,
        ...CircleConfig.legend,
        textStyle: {
            fontSize: Legend_Config.textStyle.fontSize,
            color: colors.portraitCenterTextStyleDougnutConfig
        },
    },
    tooltip: {
        trigger: 'item',
        formatter: '{b}: {d}%',
        ...Tooltip_Config,
    },
    animation: false
});
export const dougnutOption = () => {
    return {
        ...getCommonDougnutOption(),
        color: [
            colors.portraitCenterTextStyleDougnutConfigDougnutOption1,
            colors.portraitCenterTextStyleDougnutConfigDougnutOption2,
            colors.portraitCenterBarhConfigSeriesChild
        ],
        series: [
            {
                ...getDougnutSeries(),
                itemStyle: {
                    shadowBlur: 15,
                    shadowColor: colors.alertDetailsFace
                },
            }
        ],
    };
};
export const brightModeDougnutOption = () => merge({
    ...getCommonDougnutOption(),
    series: [
        {
            ...getDougnutSeries(),
            radius: [
                50 * Scale,
                70 * Scale
            ],
            center: [
                '50%',
                '40%'
            ],
        }
    ],
}, {
    legend: {
        bottom: 'bottom',
        left: 'center',
        itemGap: 32,
        textStyle: {
            color: colors.dodgerGridBlack,
        },
    }
});
export const brightAgeModeDougnutOption = () => merge(brightModeDougnutOption(), {
    color: [
        colors.portraitCenterBrightAgeModeDougnutOption,
        colors.portraitCenterBarhConfigSeriesAdult,
        colors.portraitCenterBarhConfigSeries,
    ],
});
export const brightGenderModeDougnutOption = () => merge(brightModeDougnutOption(), {
    color: [
        colors.portraitCenterBrightAgeModeDougnutOption,
        colors.portraitCenterBarhConfigSeriesAdult,
        colors.portraitCenterBarhConfigSeries,
    ],
});
export const brightIndentityModeDougnutOption = () => merge(brightModeDougnutOption(), {
    color: [
        colors.portraitCenterBarhConfigSeries,
        colors.portraitCenterBarhConfigSeriesAdult,
        colors.portraitCenterBrightAgeModeDougnutOption,
    ],
});
export const brightCustomersDougnutOption = () => merge(brightModeDougnutOption(), {
    color: [
        colors.portraitCenterBarhConfigSeriesAdult,
        colors.circleColor,
        colors.portraitCenterBarhConfigSeries,
        colors.pieGreen,
        colors.parkingRoi3dEmploy,
    ],
    legend: {
        width: 250,
        itemWidth: 10,
        itemGap: 14,
    }
});
